export default "__VITE_ASSET__DxaaJZdx__"